import {Tooltip} from 'antd';
import {ReactElement} from 'react';

import {Locale} from '../../../../../provider/locale/localization';
import {getPresenceBlockedTooltipLocaleKey} from '../../../../../service/reviews/review-realtime-presence/review-realtime-presence-helper';
import {ReviewPresenceBlockedActionEnum} from '../../../../../service/reviews/review-realtime-presence/review-realtime-presence-type';

type PropsType = {
    blockedAction: ReviewPresenceBlockedActionEnum;
    children: ReactElement;
    isBlocked: boolean;
};

export function ReviewPresenceBlockedTooltip(props: PropsType): ReactElement {
    const {blockedAction, isBlocked, children} = props;

    if (!isBlocked) {
        return children;
    }

    return (
        <Tooltip title={<Locale stringKey={getPresenceBlockedTooltipLocaleKey(blockedAction)} />}>
            <span>{children}</span>
        </Tooltip>
    );
}
